import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { CoreCommonModule } from '@core/common.module';
import { AuthInterceptor } from 'app/auth/helpers/auth.interceptor';

import { AuthLoginV2Component } from 'app/main/pages/authentication/auth-login-v2/auth-login-v2.component';
import { AuthLoginMunkatarsComponent } from './auth-login-munkatars/auth-login-munkatars.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AuthLoginV2Component, AuthLoginMunkatarsComponent],
  imports: [CoreCommonModule, RouterModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
